// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Sx, Text, useMantineTheme } from '@mantine/core';
import { useElementSize } from '@mantine/hooks';
import { FC, Key, MouseEvent as ReactMouseEvent, ReactNode } from 'react';

const BookingStateItem: FC<{
  label: string;
  active: boolean;
  color?: string;
  textColor?: string;
  bgColor?: string;
  onClick?: () => void;
  count?: number;
  countColor?: string;
  countWeight?: string;
  icon?: ReactNode;
  rightSection?: ReactNode;
  key?: Key;
  textStyle?: Sx;
  sx?: Sx;
}> = ({
  label,
  active,
  onClick,
  bgColor = 'transparent',
  color,
  textColor,
  count,
  icon,
  rightSection,
  key,
  sx,
  textStyle,
  countColor = 'dimmed',
  countWeight = 'normal',
}) => {
  const { colorScheme, colors } = useMantineTheme();
  const { ref, width } = useElementSize();
  const darkMode = colorScheme === 'dark';

  const getTextColor = () => {
    if (active) {
      if (textColor) return textColor;
      if (color) return color;
      return darkMode ? colors.blue[1] : 'black';
    }
    return darkMode ? 'white' : 'black';
  };

  return (
    <Box
      key={key}
      ref={ref}
      onClick={onClick}
      sx={(theme) => ({
        position: 'relative',
        backgroundColor: active && !darkMode ? bgColor : 'transparent',
        height: 32,
        display: 'flex',
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': {
          backgroundColor: darkMode ? theme.colors.dark[6] : theme.colors.gray[0],
        },
        ...sx,
      })}
    >
      <div
        style={{
          width: 5,
          height: 20,
          backgroundColor: active ? getTextColor() : 'transparent',
          borderRadius: 25,
          marginLeft: 20,
          marginRight: 20,
        }}
      />
      <Text
        className="overflow-ellipsis"
        color={getTextColor()}
        weight={active ? 'bolder' : 'normal'}
        sx={textStyle}
        style={{ maxWidth: width - 90 }}
      >
        {label}
      </Text>
      {(rightSection || icon) && (
        <Box
          onClick={(event: ReactMouseEvent<HTMLDivElement>) => event.stopPropagation()}
          sx={{ position: 'absolute', right: 10, display: 'flex', alignItems: 'center' }}
        >
          {rightSection || icon}
        </Box>
      )}
      {count && (
        <Box sx={{ position: 'absolute', right: 15, top: 7 }}>
          <Text size="xs" color={countColor} weight={countWeight}>
            {count}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default BookingStateItem;
